import React from 'react';
import PropTypes from 'prop-types';
import heartbeat from '../utils/heartbeat';
import format from '../utils/format';

class Duration extends React.Component {
  constructor(props) {
    super(props);
    const { children: timeFrom, pad, timeTo } = this.props;
    this.state = {
      timeFrom,
      duration: timeTo ? format.timeDiff(timeTo, timeFrom, pad) : format.timeDiffNow(timeFrom, pad),
    };
  }

  componentDidMount() {
    if (!this.props.timeTo) {
      this.heartbeat = heartbeat(() => {
        this.setState({ duration: format.timeDiffNow(this.state.timeFrom, this.props.pad) });
      });
    }
  }

  componentWillUnmount() {
    if (!this.props.timeTo) {
      this.heartbeat.remove();
    }
  }

  render() {
    const { duration, timeFrom } = this.state;
    const { style } = this.props;

    return <span title={format.granularTime(timeFrom)} style={style}>{duration}</span>;
  }
}

Duration.propTypes = {
  children: PropTypes.string.isRequired,
  pad: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  timeTo: PropTypes.string,
};

Duration.defaultProps = {
  pad: false,
  style: {},
  timeTo: null,
};

export default Duration;



// WEBPACK FOOTER //
// ./src/components/Duration.js